import { EImageType } from '../../types/offer';
import { IOfferDesktopSchema } from '../../repositories/offers-comparison/entities/offer/OfferDesktopSchema';

export function transformComparisonImages({ images }: IOfferDesktopSchema) {
  return images.map(image => ({
    ...image,
    type: image.type as unknown as EImageType,
  }));
}
